import { createContext, useEffect, useState } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

const CourseAssignmentContext = createContext();

export const CourseAssignmentContextProvider = ({ children }) => {
  let [staffData, setStaffData] = useState([]);
  let [staffs, setStaffs] = useState([]);
  let [coursetoReject, setCoursetoReject] = useState({});
  let [courseAssignmentpage, setcourseAssignmentpage] = useState(true);
  let [requestedCoursesPage, setrequestedCoursesPage] = useState(false);
  let [assignmentRequestpage, setassignmentRequestpage] = useState(false);
  let [assign, setAssigned] = useState({});
  let [showSection, setshowSection] = useState({});
  let [loadStaffComponent, setloadStaffComponent] = useState(false);
  let [batchOfOwnCourse, setBatchOfOwnCourse] = useState(0);
  let [batchOfReqCourses, setbatchOfReqCourses] = useState(0);
  let [sectionMounted, setsectionMounted] = useState(false);
  let [error, setError] = useState("");
  let [success, setsuccess] = useState("");
  let [courseSections, setCourseSections] = useState({});
  let [val, setVal] = useState("ca");
  let [offbatchcourses, setoffbatchcourses] = useState([]);

  let api = useAxiosPrivate();

  let getStaffs = async (isMounted, signal) => {
    try {
      let respstaff = await api.get(`courseallocation/alldeptstaff`, {
        signal,
      });
      console.log(respstaff.data);

      isMounted && setStaffs(respstaff.data);
    } catch (err) {
      setError(err.response.data.msg);
    }
  };

  function alignStaffData() {
    let arr = [];
    staffs.forEach((staff) => {
      let arrfordata = [
        { pic: staff?.User?.profile_pic, id: staff.id },
        staff?.User?.first_name,
        staff?.Status?.type,
        staff.Rank?.academic_type,
        staff?.TOTAL_LEH,
        staff?.REG_LEH,
        staff?.EXT_LEH,

        { assign: "Assign", id: staff.id },
        staff.id,
      ];

      arr.push(arrfordata);
    });

    setStaffData(arr);
  }

  useEffect(() => {
    alignStaffData();
  }, [staffs]);

  useEffect(() => {
    setTimeout(() => {
      setError("");
    }, 5000);
  }, [error]);

  useEffect(() => {
    setTimeout(() => {
      setsuccess("");
    }, 5000);
  }, [success]);

  async function assignStaffThoughClick(sId) {
    let resp;
    try {
      resp = await api.post("courseallocation/allocation/addstafftocourse", {
        course_code: assign.courseCode,
        group_id: assign.group_id,
        staff_id: sId,
        LEH: assign.Load,
      });
    } catch (err) {
      setError("Error while assigning Staff");
    }

    setAssigned({});
    return resp.data.msg;
  }

  async function assignstaff(gId, cId, sId, LoadLeh, assigner) {
    let resp;
    try {
      resp = await api.post("courseallocation/allocation/addstafftocourse", {
        course_code: cId,
        group_id: gId,
        staff_id: sId,
        LEH: LoadLeh,
        assigner: assigner,
      });
    } catch (err) {
      setError("Error while assigning Staff");
    }

    return resp.data.msg;
  }

  async function deAssignStaff(gId, cId, sId, LoadLeh) {
    let resp;
    try {
      resp = await api.get(
        `courseallocation/allocation/removestafffromcourse?course_code=${cId}&group_id=${gId}&staff_id=${sId}`
      );
    } catch (err) {
      setError("Error while de-assigning Staff");
    }

    return resp.data.msg;
  }

  return (
    <CourseAssignmentContext.Provider
      value={{
        staffs,
        staffData,

        setStaffs,

        getStaffs,

        assignstaff,
        deAssignStaff,
        assign,
        setAssigned,
        assignStaffThoughClick,
        error,
        setError,
        showSection,
        setshowSection,

        loadStaffComponent,
        setloadStaffComponent,
        alignStaffData,

        courseSections,
        setCourseSections,
        courseAssignmentpage,
        requestedCoursesPage,
        assignmentRequestpage,
        batchOfOwnCourse,
        setBatchOfOwnCourse,
        coursetoReject,
        setCoursetoReject,
        setassignmentRequestpage,
        setrequestedCoursesPage,
        setcourseAssignmentpage,
        sectionMounted,
        setsectionMounted,
        batchOfReqCourses,
        setbatchOfReqCourses,
        val,
        setVal,
        success,
        setsuccess,
        offbatchcourses,
        setoffbatchcourses,
      }}
    >
      {children}
    </CourseAssignmentContext.Provider>
  );
};

export default CourseAssignmentContext;
